import { FC } from 'react';
import Loader from 'components/Loader';
import { Toast } from 'components/Toast';
import Spacing from 'components/Spacing';
import { IPage } from 'store/donatePage/types';
import { IRecipient } from 'store/recipients/types';
import { ContributionRules } from './ContributionRules';
import { Candidates, CandidateType } from './Candidates/Candidates';
import { SlateContainer } from './styled';
import { OathRecurringInterval } from 'store/pay/types';
import { AmountDetailsContent } from './AmountDetails/Content';

interface Props {
  page?: IPage;
  isDafEnabled: boolean;
  candidates: CandidateType[];
  onSelectCandidates: (updatedCandidates: CandidateType[]) => void;
  recipients: IRecipient[];
  selectedDonationAmount?: number;
  overageMax?: number;
  onDonateClick: (selectedMethod?: string) => void;
  onUserDonationTotalChange: (value?: number) => void;
  setCandidates: React.Dispatch<React.SetStateAction<CandidateType[]>>;
  setSelectedDonationAmount: React.Dispatch<React.SetStateAction<number | undefined>>;
  showCustomSplit: boolean;
  onDafDonateClick: () => void;
  isRecurring: boolean;
  setIsRecurring: (isRecurring: boolean) => void;
  recurringInterval: OathRecurringInterval;
  isMonthlyEnabled: boolean;
  enableScrollToDonate: boolean;
}

export const CompactSlate: FC<Props> = ({
  page,
  candidates,
  isDafEnabled,
  onDonateClick,
  onSelectCandidates,
  onUserDonationTotalChange,
  recipients,
  selectedDonationAmount,
  overageMax,
  setCandidates,
  setSelectedDonationAmount,
  showCustomSplit,
  onDafDonateClick,
  isRecurring,
  setIsRecurring,
  recurringInterval,
  isMonthlyEnabled,
  enableScrollToDonate,
}) => {
  if (!page || !recipients) {
    return <Loader width={60} height={60} />;
  }

  return (
    <SlateContainer className="compact-slate">
      <Toast />
      <Candidates
        allocationType={page.allocation_type}
        candidates={candidates}
        recipientCount={recipients.length}
        setCandidates={onSelectCandidates}
      />
      <AmountDetailsContent
        page={page}
        candidates={candidates}
        isDafEnabled={isDafEnabled}
        onDonateClick={onDonateClick}
        onUserDonationTotalChange={onUserDonationTotalChange}
        selectedDonationAmount={selectedDonationAmount}
        overageMax={overageMax}
        setCandidates={setCandidates}
        setSelectedDonationAmount={setSelectedDonationAmount}
        showCustomSplit={showCustomSplit}
        onDafDonateClick={onDafDonateClick}
        isRecurring={isRecurring}
        setIsRecurring={setIsRecurring}
        recurringInterval={recurringInterval}
        isMonthlyEnabled={isMonthlyEnabled}
        enableScrollToDonate={enableScrollToDonate}
      />
      <Spacing $size={147} />
      <ContributionRules />
      <Spacing $size={14.5} />
    </SlateContainer>
  );
};
